import React from 'react';
import { Button } from 'react-bootstrap';
import { RiSendPlaneFill } from 'react-icons/ri';
import styled from 'styled-components';

const SubmitBtn = ({ withText, btnText }) => {
  if (withText) {
    return (
      <StyledTextBtn type="submit">
        <span>
          <RiSendPlaneFill />
        </span>
        <span>{btnText}</span>
      </StyledTextBtn>
    );
  }
  return (
    <StyledIconBtn type="submit">
      <span>
        <RiSendPlaneFill />
      </span>
    </StyledIconBtn>
  );
};

const StyledTextBtn = styled(Button)`
  background-color: ${(props) => props.theme.colors.transparent};
  color: ${(props) => props.theme.colors.black};
  border-radius: 0;
  border: 2px solid ${(props) => props.theme.colors.black};
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 0.75rem;

  & > span {
    line-height: 1;

    &:nth-of-type(1) {
      margin-right: 0.4rem;
    }
  }

  &:hover,
  &:active {
    background-color: ${(props) => props.theme.colors.primary};
    border-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.white};
  }
`;

const StyledIconBtn = styled(Button)``;

export default SubmitBtn;
